import JobDetailsSection from './JobDetailsSection';

export default JobDetailsSection;
